module.exports = __webpack_public_path__ + "img/image-compare.d9ab41e0.svg";